import { domContentLoaded } from '@flowio/browser-helpers';
import { isNil, isString } from '@flowio/is';
import { TaskQueue } from '@flowio/task-queue';
import createObserver from './createObserver';
import getLocation from './getLocation';

function normalizeParameter(value) {
  return value === null || value === void 0 ? void 0 : value.replace(/["'<>\\]/g, '');
}

export default function createProvider() {
  var queryParams = new URLSearchParams(window.location.search);
  var channelId = normalizeParameter(queryParams.get('channelId'));
  var targetOrigin = normalizeParameter(queryParams.get('origin'));
  var observer = createObserver();
  var queue = new TaskQueue();
  var targetWindow = null;

  function receiveMessage(event) {
    var origin = getLocation(event.origin);

    if (!isNil(channelId) && !isNil(targetOrigin) && origin === targetOrigin && isString(event.data) && event.data.substring(0, channelId.length + 1) === "".concat(channelId, " ")) {
      var message = event.data.substring(channelId.length + 1);
      observer.notify(JSON.parse(message));
    }
  }

  function subscribe(subscriber) {
    return observer.subscribe(subscriber);
  }

  function postMessage(action) {
    queue.insert(function () {
      if (!isNil(channelId) && !isNil(targetOrigin) && !isNil(targetWindow)) {
        var message = "".concat(channelId, " ").concat(JSON.stringify(action));
        targetWindow.postMessage(message, targetOrigin);
      }
    });
  }

  function destroy() {
    window.removeEventListener('message', receiveMessage);
  }

  domContentLoaded(function () {
    if (!isNil(channelId) && !isNil(targetOrigin)) {
      targetWindow = window.parent;
      window.addEventListener('message', receiveMessage);
      targetWindow.postMessage("".concat(channelId, "-ready"), targetOrigin);
      queue.ready();
    }
  });
  return {
    destroy: destroy,
    postMessage: postMessage,
    subscribe: subscribe
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/createProvider.js
// module id = 650
// module chunks = 0 1